'use strict';

const _ = require('lodash');
const { architectureGroupLevel } = require('../enums/hierarchy');
const timeFlexibleEndingsMap = require('../enums/time-flexible-endings');
const {
  timeFlexibleAggregations,
  timeFlexibleIndependentAggregations,
  timeFlexibleGridViewFields,
  timeFlexibleIndependentGridViewFields,
  additionalCostFields,
} = require('../enums/time-flexible-fields');
const { yearly } = require('../enums/historical-periods');
const { showAdditionalCostTypes } = require('../enums/feature-flags');

const getTimeFlexibleFieldSuffix = selectedHistoricalPeriod => {
  return selectedHistoricalPeriod === yearly ? '' : selectedHistoricalPeriod;
};


const mapTimeFlexibleData = (
  selectedHistoricalPeriod,
  timeFlexibleFields,
  timeFlexibleIndependentFields,
  additionalCostFields = [],
  forExport = false
) => {
  const fieldSuffix = getTimeFlexibleFieldSuffix(selectedHistoricalPeriod);
  return item => {
    const mappedItem = forExport ? [] : _.pick(item, showAdditionalCostTypes ? [...timeFlexibleIndependentFields, ...additionalCostFields] : timeFlexibleIndependentFields);
    timeFlexibleFields.forEach(field => {
      // deal with yearlySales/ yearlyVolumes
      if (_.includes(field, yearly) && fieldSuffix) {
        const timeFlexibleField = field.replace(yearly, '').toLowerCase();
        mappedItem[field] = item[timeFlexibleField.concat(fieldSuffix)];
      } else {
        mappedItem[field] = item[field.concat(fieldSuffix)];
      }
    });
    return mappedItem;
  };
};

const mapAggregations = selectedHistoricalPeriod => {
  return mapTimeFlexibleData(
    selectedHistoricalPeriod,
    timeFlexibleAggregations,
    timeFlexibleIndependentAggregations
  );
};

const mapGridView = (selectedHistoricalPeriod, forExport = false) => {
  return mapTimeFlexibleData(
    selectedHistoricalPeriod,
    timeFlexibleGridViewFields,
    timeFlexibleIndependentGridViewFields,
    additionalCostFields,
    forExport
  );
};
const getTimeFlexibleItems = (items, selectedHistoricalPeriod) => {
  const mapGridViewBySelectedHistoricalPeriod = mapGridView(selectedHistoricalPeriod);
  const pathToArchitectureGroupDescription = [
    'hierarchy',
    architectureGroupLevel,
    'levelEntryDescription',
  ];

  return items.map(item => {
    return {
      ...mapGridViewBySelectedHistoricalPeriod(item),
      // makes it easier to access the field
      architectureGroupDescription: _.get(item, pathToArchitectureGroupDescription),
      // all historical period volume values required for price recalculation
      ..._.keys(timeFlexibleEndingsMap).reduce((acc, ending) => {
        acc[`volume${ending}`] = _.get(item, `volume${ending}`, 0);
        return acc;
      }, {}),
    };
  });
};

module.exports = {
  mapAggregations,
  mapGridView,
  getTimeFlexibleItems,
  getTimeFlexibleFieldSuffix,
};
